import script from "./BitcoinDetailBlocksSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./BitcoinDetailBlocksSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./BitcoinDetailBlocksSkeleton.vue?vue&type=style&index=0&id=7c00298e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c00298e"]])

export default __exports__